export default "__VITE_ASSET__88O1fWg6__"